import { ViewModel,View, ObservableArray } from "binder"
import  { ReceiptBillListView } from "./receiptBillList-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import moment from "moment";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ReceiptBillDetailViewModel } from "../receiptBillDetail/receiptBillDetail-viewModel";
import { WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { SetReceiptBillsPriceViewModel } from "../setReceiptBillsPrice/setReceiptBillsPrice-viewModel";

export class ReceiptBillListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست رسیدهای انبار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filterDayTo = moment.utc();
        this.rows = ObservableArray.create<row>();
        this.warehouseSelector = new WarehouseSelectorViewModel(this);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.warehouseId = w.id;
        }
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        
    }
    GetDefaultView(): View <ViewModel> {
        return new ReceiptBillListView();
    }
    public getTypeId(): string {
        return "VM-D813140C-A213-43DB-BB23-A4800DB0AF86"
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set filterDayFrom(v: moment.Moment) { this._filterDayFrom = v; } public get filterDayFrom(): moment.Moment { return this._filterDayFrom;} private _filterDayFrom: moment.Moment;
    public set filterDayTo(v: moment.Moment) { this._filterDayTo = v; } public get filterDayTo(): moment.Moment { return this._filterDayTo;} private _filterDayTo: moment.Moment;
    public set filterBillCode(v: string) { this._filterBillCode = v; } public get filterBillCode(): string { return this._filterBillCode;} private _filterBillCode: string;
    public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    
    async showDetail(bill: row) {
        let receiptDetail = new ReceiptBillDetailViewModel(this);
        receiptDetail.loadById(bill.id);
        let result = await this.showPopup(receiptDetail);
        if(result = true){
            this.refresh();
        }
        try {
            this.isLoading = true;
            
            if(result.IsSuccessful){
                
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
        
    async setAutomatic() {
        let receiptDetail = new SetReceiptBillsPriceViewModel(this);
        let result = await this.showPopup(receiptDetail);
        
    }
    
    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> 
    {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllReceiptBills',{
                FilteringInformation:filteringInformation,
                WarehouseId: this.warehouseId,
                BillCode: this.filterBillCode,
                FromDate: this.filterDayFrom,
                UntilDate: this.filterDayTo,
            });
            this.rows.update(...result.ReceiptBills.map((x,i)=>{
                let r = new row(this);
                r.index = i+1;
                r.id = x.BillId;
                r.time = moment.utc(x.CreatedTime);
                r.receiptNo = x.BillNo;
                r.partyName = x.PartyName;
                r.warehouseName = x.WarehouseName;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

}

export class row extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReceiptBillListViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent : ReceiptBillListViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set receiptNo(v: string) { this._receiptNo = v; } public get receiptNo(): string { return this._receiptNo;} private _receiptNo: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName; } private _partyName: string;
    
    async showDetail(){
        try {
            this._typedParent.showDetail(this);
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}
